<div *ngIf="reminderData.isCompleted; else otherStatusReminder"
     class="reminder-card-cont gap-3 reminder-card-done" (click)="viewReminder()">
    <div class="d-flex justify-content-center align-items-center">
        <mat-icon class="radio-icon">
            radio_button_checked
        </mat-icon>
    </div>
    <div class="d-flex justify-content-between align-items-center flex-fill gap-1 r-card-title-date"
         matTooltip="View Reminder" [matTooltipShowDelay]=500>
        <div class="reminder-title">
            {{ reminderData.reminderTitle }}
        </div>
        <div class="reminder-timing-done">
            {{ reminderData.reminderDateTime | todayOrOtherDate }}
        </div>
    </div>
</div>

<ng-template #otherStatusReminder>
    <div class="reminder-card-cont gap-3" (click)="viewReminder()">
        <div class="d-flex justify-content-center align-items-center">
            <mat-icon class="radio-icon" (click)="markAsDone($event)" matTooltip="Mark As Done"
                      [matTooltipShowDelay]="500">
                radio_button_unchecked
            </mat-icon>
        </div>
        <div class="d-flex justify-content-between align-items-center flex-fill gap-1 r-card-title-date"
             matTooltip="View/Edit" [matTooltipShowDelay]=500>
            <div class="reminder-title">
                {{ reminderData.reminderTitle }}
            </div>
            <div class="reminder-timing">
                {{ reminderData.reminderDateTime | todayOrOtherDate }}
            </div>
        </div>
    </div>
</ng-template>